import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g clipPath="url(#clip0_1746_27053)">
        <path
          fill="#13CB75"
          d="M9 16.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm-.75-5.25v1.5h1.5v-1.5h-1.5zm0-6v4.5h1.5v-4.5h-1.5z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1746_27053">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
